import { render, staticRenderFns } from "./item_collection.vue?vue&type=template&id=e733fc62&"
import script from "./item_collection.vue?vue&type=script&lang=js&"
export * from "./item_collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports